import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    '热门栏目': [
      { name: '黑料今日', href: '/category/heiliao-jinri' },
      { name: '网红塌房', href: '/category/wanghong-tafang' },
      { name: '明星私聊', href: '/category/mingxing-siliao' },
      { name: '黑料视频', href: '/category/heiliao-shipin' },
    ],
    '关于我们': [
      { name: '品牌介绍', href: '/about' },
      { name: '联系我们', href: '/about#contact' },
      { name: '用户口碑', href: '/about#reputation' },
      { name: '最新地址', href: '/about#address' },
    ],
    '下载与帮助': [
      { name: 'Android 下载', href: '/category/heiliao-jinri' },
      { name: 'iOS 下载', href: '/category/heiliao-jinri' },
      { name: '常见问题', href: '/about#faq' },
      { name: '使用教程', href: '/about#guide' },
    ],
    '友情链接': [
      { name: '吃瓜第一线', href: '#' },
      { name: '娱乐爆料台', href: '#' },
      { name: '黑料档案馆', href: '#' },
      { name: '网红观察室', href: '#' },
    ],
  };

  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='1200' height='600' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M200,300 Q400,100 600,300 T1000,300' fill='none' stroke='white' stroke-width='0.5'/%3E%3Cpath d='M100,200 Q350,50 600,200 T1100,200' fill='none' stroke='white' stroke-width='0.3'/%3E%3Cpath d='M150,400 Q400,250 650,400 T1050,400' fill='none' stroke='white' stroke-width='0.3'/%3E%3Ccircle cx='300' cy='150' r='2' fill='white' opacity='0.3'/%3E%3Ccircle cx='700' cy='350' r='1.5' fill='white' opacity='0.3'/%3E%3Ccircle cx='500' cy='450' r='1' fill='white' opacity='0.2'/%3E%3C/svg%3E")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>

        <div className="relative mx-auto px-4 md:px-6 max-w-[1400px] py-14 md:py-20">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            <div className="lg:w-[320px] flex-shrink-0">
              <Link to="/" className="inline-block">
                <span className="text-2xl md:text-3xl font-heading font-bold text-background-50 tracking-tight">
                  今日看料
                </span>
                <span className="block text-sm text-background-50/50 mt-1 font-light">
                  全网吃瓜第一入口
                </span>
              </Link>
              <p className="mt-6 text-sm text-background-50/60 leading-relaxed max-w-[280px]">
                每日持续更新最新吃瓜爆料内容，涵盖网红塌房、明星私聊、综艺黑幕等热门话题。不做谣言的制造者，只做真相的搬运工。
              </p>
              <div className="flex items-center gap-3 mt-6">
                {['ri-wechat-line', 'ri-weibo-line', 'ri-tiktok-line', 'ri-bilibili-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-50/20 text-background-50/70 hover:bg-background-50/10 hover:text-background-50 transition-all duration-200 cursor-pointer"
                    aria-label="社交媒体"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8">
              {Object.entries(footerLinks).map(([title, links]) => (
                <div key={title}>
                  <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">
                    {title}
                  </h4>
                  <ul className="flex flex-col gap-2.5">
                    {links.map((link) => (
                      <li key={link.name}>
                        {link.href.startsWith('#') ? (
                          <a
                            href={link.href}
                            className="text-sm text-background-50/50 hover:text-background-50 transition-colors duration-200"
                          >
                            {link.name}
                          </a>
                        ) : (
                          <Link
                            to={link.href}
                            className="text-sm text-background-50/50 hover:text-background-50 transition-colors duration-200"
                          >
                            {link.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; 2026 今日看料 JinRiKanLiao.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
                用户协议
              </a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}